/**
 *  @class
 *  @function Gallery
 */
if (!customElements.get('theme-gallery')) {
  class ThemeGallery extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.galleryVideoList = Array.from(this.querySelectorAll('.gallery--video'));
      this.galleryVideoList.forEach((item) => {
        const video = item.querySelector('video');
        if (!video) return;

        video.muted = true;
        video.playsInline = true;
        video.autoplay = true;
        video.play().catch(() => {});
      });

      this.setAnimations();

      if (Shopify.designMode) {
        this.addEventListener('shopify:section:load', (event) => {
          this.setAnimations();

          setTimeout(() => {
            ScrollTrigger.refresh();
          }, 100);
        });
      }
    }

    setAnimations() {
      ScrollTrigger.batch(this.querySelectorAll('figure'), {
        start: "top 90%",
        onEnter: (elements, triggers) => {
          gsap.to(elements, { opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
        },
      });
    }
  }
  customElements.define('theme-gallery', ThemeGallery);
}
